export default __webpack_public_path__ + "static/media/atm-d.29c2de60.png";